/* screens/academy/ruDate.js — дата фильтра по-русски.

   Нативный <input type="date"> печатает дату в локали БРАУЗЕРА, а не страницы:
   в RU-продукте методисту показывалось mm/dd/yyyy, и «сдано после 03.08» он
   набирал как 3 августа, получая 8 марта. Формат ввода задаём сами; наружу
   значение уходит ВСЕГДА в ISO — его и ждёт бэк (?submitted_after=YYYY-MM-DD).

   Отдельный модуль, чтобы разбор даты проверялся тестом, а не глазом на экране. */

/** «дд.мм.гггг» → «ГГГГ-ММ-ДД». null — строка не является полной корректной датой. */
export function ruDateToIso(s) {
  const m = /^\s*(\d{1,2})[.\-/](\d{1,2})[.\-/](\d{4})\s*$/.exec(String(s == null ? '' : s));
  if (!m) return null;
  const d = Number(m[1]);
  const mo = Number(m[2]);
  const y = Number(m[3]);
  // new Date(2026, 1, 31) молча уезжает на 3 марта — сверяем компоненты обратно,
  // иначе фильтр отфильтровал бы по другой дате, ничего не сказав.
  const dt = new Date(y, mo - 1, d);
  if (dt.getFullYear() !== y || dt.getMonth() !== mo - 1 || dt.getDate() !== d) return null;
  return `${y}-${String(mo).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
}

/** «ГГГГ-ММ-ДД…» → «дд.мм.гггг». Пустая строка — значения нет. */
export function isoToRuDate(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso == null ? '' : iso));
  return m ? `${m[3]}.${m[2]}.${m[1]}` : '';
}
